/// PRECISA REFATORAR ESSA COMPONENTE PARA UTILIZAR MUI E OTIMIZAR AS ANIMAÇÕES É CÓDIGO ANTIGO. ass:Victor

import React, { useEffect, useState } from "react";
import RewardChest from "./components/RewardChest";
import MessageAchievements from "./components/MessageAchievements";
import { useModalReward } from "./hooks/useModalReward";
import { Box } from "@mui/material";
import ButtonCloseReward from "./components/ButtonCloseReward";

const ModalReward = ({
  rewards,
  setInfoActivity,
  setOpenMedal,
  setOpenGame,
}) => {
  const [content, setContent] = useState(<></>);
  const [showMedal, setShowMedal] = useState(false);
  const [medalMap, setMedalMap] = useState({});

  const { handleNavigate, closeReward } = useModalReward(
    setInfoActivity,
    setOpenMedal,
    setOpenGame,
    rewards,
    setShowMedal,
    medalMap,
    showMedal
  );

  useEffect(() => {
    if (showMedal) {
      // pega a primeira medalha recebida
      const medalContent = rewards[0];

      // atualiza essa medalha no objeto medalMap
      setMedalMap((prev) => {
        return {
          ...prev, //mantem medalhas já salvas
          [medalContent.medal_id]: medalContent, // salva a medalha atual
        };
      });
      setContent(
        <>
          {/* Componente das animações do baú */}
          <RewardChest medalContent={medalContent} />
          <Box>
            {/* Componente da mensagem abaixo do baú */}
            <MessageAchievements
              medalContent={medalContent}
              handleNavigate={handleNavigate}
            />
            <ButtonCloseReward closeReward={closeReward} />
          </Box>
        </>
      );
    }
  }, [showMedal, rewards]);

  return (
    <Box
      id="modal_medal"
      sx={{
        position: "fixed",
        zIndex: 10002,
        width: "100%",
        height: "100%",
        top: "0",
        display: "none",
      }}
    >
      <Box
        id="black_fade"
        sx={{
          backgroundColor: "rgba(0,0,0,0.8)",
          opacity: "0.0",
          width: "100%",
          height: "100%",
          webkitTransition: "all 0.5s ease",
          mozTransition: "all 0.5s ease",
          oTransition: "all 0.5s ease",
          msTransition: "all 0.5s ease",
          transition: "all 0.5s ease",
          display: "flex",
          alignItems: "center",
          justifyContent: "flex-start",
          flexDirection: "column",
          paddingTop: "10%",

          // desktop
          "@media (min-height: 768px)": {
            paddingTop: "10%;",
          },

          // mobile
          "@media (max-height: 767px),(max-width: 767px)": {
            paddingTop: "15vh",
            overflowY: "scroll",
          },
        }}
      >
        {content}
      </Box>
    </Box>
  );
};
export default ModalReward;
